module.exports = __webpack_public_path__ + "img/plastics-img-5.1a9aa6d0.png";